import { DiscountUpdateEvent } from '@theme/events';

// Display follows Shopify's clock. The scheduled native BXGY owns cart/checkout prices.
(() => {
  const config = document.querySelector('[data-crown-energy-schedule]');
  if (!config) return;
  const start = Date.parse(config.dataset.startsAt);
  const end = Date.parse(config.dataset.endsAt);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
  const preview = config.dataset.preview === 'true';
  const root = document.documentElement;
  let serverTime, sampledAt, timer, synchronizing = false, refreshPending = false;
  const now = () => serverTime + performance.now() - sampledAt;
  function update() {
    clearTimeout(timer);
    const time = now();
    const enabled = preview || (time >= start && time < end);
    const changed = root.hasAttribute('data-crown-energy-active') !== enabled;
    root.toggleAttribute('data-crown-energy-active', enabled);
    if (changed) document.dispatchEvent(new Event('crown:energy-schedule'));
    if (!preview && time < end) timer = setTimeout(() => { update(); synchronize(true); }, Math.min((enabled ? end : start) - time, 2147483647));
    return changed;
  }
  async function synchronize(refreshCart = false) {
    if (synchronizing) return;
    synchronizing = true;
    try {
      const url = new URL(config.dataset.cartUrl, location.origin);
      url.searchParams.set('_crown_clock', String(Date.now()));
      const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
      const date = Date.parse(response.headers.get('Date'));
      if (!response.ok || !Number.isFinite(date)) throw new Error('Shopify clock unavailable');
      let cart = await response.json();
      serverTime = date; sampledAt = performance.now();
      const changed = update();
      if (changed || refreshCart || refreshPending) {
        refreshPending = true;
        if (cart.item_count > 0 && (preview || now() >= start)) {
          const updated = await fetch(config.dataset.cartUpdateUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: {} }) });
          if (!updated.ok) throw new Error('Shopify cart recalculation unavailable');
          cart = await updated.json();
        }
        refreshPending = false;
        document.dispatchEvent(new DiscountUpdateEvent(cart, 'crown-energy-promotion'));
      }
    } catch {
      // Never start a public promotion from an untrusted device clock.
    } finally { synchronizing = false; }
  }
  document.addEventListener('visibilitychange', () => { if (!document.hidden) synchronize(true); });
  window.addEventListener('pageshow', () => synchronize(true));
  window.addEventListener('online', () => synchronize(true));
  setInterval(() => { if (!document.hidden && (!Number.isFinite(serverTime) || now() < end)) synchronize(); }, 60000);
  synchronize(true);
})();
